export const MESSAGES = {
    REFRESH_RECENTLY_PLAYED: 'REFRESH_RECENTLY_PLAYED',
    RELOAD_REQUIRED: 'RELOAD_REQUIRED',
    LOGOUT_REQUIRED: 'LOGOUT_REQUIRED',
    ACCOUNT_HUB_SHOW_BALANCE_CHANGED: 'ACCOUNT_HUB_SHOW_BALANCE_CHANGED',
    VERIFY_REALITY_CHECK: 'VERIFY_REALITY_CHECK',
    CLOSE_REALITY_CHECK_MODAL: 'CLOSE_REALITY_CHECK_MODAL'
};

export const TRUSTED_ORIGIN_PATTERNS = [
    /^https:\/\/(refer|account\.[^.]+)\.casino\.fanduel\.com$/,
    /^https:\/\/(refer|account\.[^.]+)\.casino\.fanduel\.ca$/,
    /^https:\/\/(refer|account)\.ct\.mohegansuncasino\.com$/,
    /^https:\/\/(refer|account\.[^.]+)\.casino\.cert\.fndl\.dev$/,
    /^https:\/\/(refer|account\.ct)\.mohegansun\.cert\.fndl\.dev$/,
    /^https:\/\/(refer|account\.[^.]+)\.casino\.cert\.canada\.fndl\.dev$/,
    /^https:\/\/(refer|account\.[^.]+)\.casino\.qa\.canada\.fndl\.dev$/
];

export type MessageData = {
    type: (typeof MESSAGES)[keyof typeof MESSAGES];
};

export type Message<T = MessageData> = MessageEvent<T>;

export type ObserverFn = (event: Message<any>) => Promise<void> | void;

export type MessageBroker = {
    observers: ObserverFn[];
    subscribe: (observer: ObserverFn) => void;
    unsubscribe: (observer: ObserverFn) => void;
    notify: (message: Message) => void;
    register: () => () => void;
};
